

import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const LeftIcon = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_940_25258)">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.2923 9.00331H4.98893L9.55059 4.45997C9.96559 4.04997 9.96559 3.38414 9.55059 2.97414C9.13643 2.56331 8.46393 2.56331 8.04893 2.97414L1.67559 9.31081C1.58393 9.40164 1.51809 9.50914 1.46643 9.62247C1.44976 9.65747 1.44059 9.69164 1.42893 9.72664C1.40059 9.81164 1.38309 9.89664 1.37726 9.98664C1.37476 10.0233 1.36976 10.0575 1.37143 10.0941C1.37559 10.2066 1.39476 10.3175 1.43643 10.425C1.43976 10.4341 1.43976 10.4433 1.44393 10.4525C1.44393 10.4541 1.44393 10.455 1.44476 10.4566C1.49476 10.575 1.56809 10.675 1.65309 10.765C1.66226 10.775 1.66559 10.7875 1.67476 10.7975L8.04809 17.1125C8.25559 17.3175 8.52726 17.42 8.79893 17.42C9.07059 17.42 9.34143 17.3175 9.54893 17.1125C9.96393 16.7016 9.96393 16.0366 9.54893 15.6258L4.98726 11.105H17.2906C17.8773 11.105 18.3514 10.635 18.3514 10.0533C18.3531 9.47414 17.8789 9.00331 17.2923 9.00331Z" fill="#2E434D"/>
      </g>
      <defs>
      <clipPath id="clip0_940_25258">
      <rect width="20" height="20" fill="white"/>
      </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default LeftIcon;